export default function initGlobal() {
    /**
     * Email protection from spam
     */
    document.querySelectorAll('[data-action="encoded"]').forEach(link => {
        link.addEventListener('click', () => {
            let newLink = "mailto:"
            for (let l of link.dataset.link) {
                if (l === '@') {
                    l = '.'
                } else if (l === '.') {
                    l = '@'
                }
                newLink += l
            }
            link.href = newLink
        }, true)
    })
}
